import { Text } from '@storyofams/react-ui';
import styled from 'styled-components';

export const Subtext = styled(Text).attrs((attrs) => ({
  color: 'black60',
  fontSize: 2,
  lineHeight: '140%',
  ...attrs,
}))``;
